import { useState } from "react";
import FormField from "@/components/common/FormField";
import { Button } from "@/components/ui/button";
import { useForm, type SubmitHandler } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesLink } from "@/utility/RouteLinks";
import { errorTypes } from "@/utility/validation";
import { callApi, ThrowError } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
// import { showToastNotification } from "@/utility/helper";
import { Loader2, ArrowLeft } from "lucide-react";
import AuthLayout from "./AuthLayout";
import { showToastNotification } from "@/utility/helper";

interface IResetPasswordForm {
    password: string;
    confirmPassword: string;
}

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const deviceId = location.state?.deviceId;
    const email = location?.state?.email

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<IResetPasswordForm>();

    const password = watch("password");

    const onSubmit: SubmitHandler<IResetPasswordForm> = async (data) => {
        try {
            setIsLoading(true);
            const API = `${API_ENDPOINT?.auth}/forget-password`;
            console.log("API", data, deviceId);
            const response = await callApi(API, {
                method: "POST",
                data: { password: data.password, deviceId, email: email },
            });

            if (response?.status === true) {
                navigate(RoutesLink?.authRoutes?.login);
                showToastNotification("success", "Password reset successfully!");
            } else {
                showToastNotification("danger", response?.message || "Reset failed");
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AuthLayout
        >
            <div className="mt-8 space-y-6">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    <FormField
                        type="password"
                        placeholder="••••••••"
                        label="New Password"
                        {...register("password", {
                            ...errorTypes?.required("Password"),
                            // ...errorTypes?.password,
                        })}
                        error={errors?.password && (errors?.password?.message as string)}
                    />

                    <FormField
                        type="password"
                        placeholder="••••••••"
                        label="Confirm Password"
                        {...register("confirmPassword", {
                            ...errorTypes?.required("Confirm password"),
                            validate: (value) => value === password || "Passwords do not match",
                        })}
                        error={errors?.confirmPassword && (errors?.confirmPassword?.message as string)}
                    />

                    {/* <div className="bg-slate-50 dark:bg-slate-800/50 p-4 rounded-xl border border-slate-100 dark:border-slate-700/50">
                        <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3">Password Requirements:</h4>
                        <ul className="space-y-2">
                            {[
                                { label: "At least 6 characters", met: password?.length >= 6 },
                                { label: "One uppercase letter", met: /[A-Z]/.test(password || "") },
                                { label: "One special character", met: /[\W_]/.test(password || "") },
                            ].map((req, i) => (
                                <li key={i} className="flex items-center gap-2 text-sm">
                                    <CheckCircle2 size={14} className={req.met ? "text-wiser-teal" : "text-slate-300"} />
                                    <span className={req.met ? "text-wiser-ink font-medium" : "text-wiser-muted"}>{req.label}</span>
                                </li>
                            ))}
                        </ul>
                    </div> */}

                    <Button
                        className="w-full shadow-lg shadow-wiser-teal/20"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <Loader2 className="h-5 w-5 animate-spin" />
                        ) : (
                            "Reset Password"
                        )}
                    </Button>
                </form>

                <div className="flex justify-center mt-6">
                    <button
                        onClick={() => navigate(RoutesLink?.authRoutes?.login)}
                        className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-wiser-ink transition-colors cursor-pointer group"
                    >
                        <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                        Back to Sign In
                    </button>
                </div>
            </div>
        </AuthLayout>
    );
};

export default ResetPassword;

